export default __webpack_public_path__ + "static/media/Zoonostic_black.6062d901.svg";